export const addZeroPrefix = (index: number) => {
  if (index >= 10) {
    return index;
  }

  return `0${index}`;
};
